export default __webpack_public_path__ + "static/media/mods_projects.cf58c046.png";